import type { DerivedContext, RatingIndex, RatingValue } from './data-views.ts';

/**
 * F6/C — single-engineer "Talent Profile" platform map. When exactly one
 * person is selected on the Talent view, the matrix flips from
 * derivedContexts × engineers to derivedContexts × business functions, shaded by
 * THAT engineer's proficiency (grayscale).
 *
 * `profileCellRating` is the per-cell value: the engineer's proficiency in a
 * derivedContext AS IT APPLIES to a business function — the max rating across the
 * derivedContext's skills that reach that function. null when the derivedContext
 * doesn't serve the function or the engineer has no rating in a reaching
 * skill (an empty cell).
 */
export function profileCellRating(
  comp: DerivedContext,
  fnId: string,
  engineerId: string,
  ratingIndex: RatingIndex,
  skillFunctions: Map<string, Set<string>>,
): RatingValue | null {
  const perEngineer = ratingIndex.get(engineerId);
  if (!perEngineer) return null;
  let best: RatingValue | null = null;
  for (const skill of comp.skills) {
    if (!skillFunctions.get(skill.id)?.has(fnId)) continue;
    const rating = perEngineer.get(skill.id);
    if (rating != null && (best === null || rating > best)) best = rating;
  }
  return best;
}
